import Android from '@mui/icons-material/Android'
import Apple from '@mui/icons-material/Apple'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormLabel from '@mui/material/FormLabel'
import RadioGroup from '@mui/material/RadioGroup'
import { styled } from '@mui/material/styles'
import { getStoreName } from 'api/application/utils'
import Radio from 'components/shared/inputs/Radio'
import TextField from 'components/shared/inputs/TextField'
import { Controller, useFormContext } from 'react-hook-form'

const AppDetails = () => {
  const { control, watch } = useFormContext()

  const platform = watch('platform')
  const notInStore = watch('notInStore')

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Alert severity="warning">You cannot change the platform later.</Alert>
      <Controller
        name="platform"
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <FormControl {...field} component="fieldset" id="platform">
            <FormLabel
              sx={{ mb: 1, fontSize: 12 }}
              htmlFor="platform"
              aria-label="Platform"
            >
              Platform
            </FormLabel>
            <StyledRadioGroup>
              <Radio
                value="android"
                checked={field.value === 'android'}
                label="Android"
                renderIcon={() => <Android sx={{ color: '#70D68C' }} />}
              />
              <Radio
                value="ios"
                checked={field.value === 'ios'}
                label="iOS"
                renderIcon={() => <Apple sx={{ color: '#D6D6D6' }} />}
              />
            </StyledRadioGroup>
          </FormControl>
        )}
      />
      <Controller
        name="name"
        control={control}
        rules={{ required: true }}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            id="name"
            label="Name"
            error={!!fieldState.error}
            helperText={fieldState.error ? 'This field is required' : null}
          />
        )}
      />
      <Controller
        name="notInStore"
        control={control}
        render={({ field }) => (
          <FormControlLabel
            sx={{ width: '250px' }}
            label="This app is not in the app store"
            control={
              <Checkbox {...field} checked={field.value} id="notInStore" />
            }
          />
        )}
      />
      {/* TODO move pattern to utils/shared? */}
      <Controller
        name="storeUrl"
        control={control}
        rules={{
          pattern:
            !notInStore &&
            /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/%?#[\]@!$&'()*+,;=.]+$/i,
          required: !notInStore,
        }}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            id="storeUrl"
            disabled={notInStore}
            label="Store URL"
            labelHint={`Use the ${getStoreName(
              platform
            )} URL, if your app is in the store`}
            error={!notInStore && !!fieldState.error}
            helperText={
              !notInStore && fieldState.error
                ? 'Please enter a correct URL'
                : null
            }
          />
        )}
      />
    </Box>
  )
}

export default AppDetails

const StyledRadioGroup = styled(RadioGroup)`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  gap: 12px;
`
